var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 1.33301C4.32659 1.33301 1.33325 4.32634 1.33325 7.99967C1.33325 11.673 4.32659 14.6663 7.99992 14.6663C11.6733 14.6663 14.6666 11.673 14.6666 7.99967C14.6666 4.32634 11.6733 1.33301 7.99992 1.33301ZM11.1866 6.46634L7.40658 10.2463C7.31325 10.3397 7.18658 10.393 7.05325 10.393C6.91992 10.393 6.79325 10.3397 6.69992 10.2463L4.81325 8.35967C4.61992 8.16634 4.61992 7.84634 4.81325 7.65301C5.00658 7.45967 5.32658 7.45967 5.51992 7.65301L7.05325 9.18634L10.4799 5.75967C10.6733 5.56634 10.9933 5.56634 11.1866 5.75967C11.3799 5.95301 11.3799 6.26634 11.1866 6.46634Z",
    fill: "#7CCA62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/greenTick.a491fdce8090558b6bfc85b06fc106dd.svg";
export { ForwardRef as ReactComponent };